export default __webpack_public_path__ + "static/media/re.0bf1dd02.svg";